
export interface SortInfo {
    currentSortBy: SortByType;
    orders: {
        [key in SortByType]?: boolean; // true = ascendant, false = descendant
    };
}


export enum SortByType {
    FileType,
    FileName,
    CreationDate,
    DueDate,
    DocumentType,
    Entity,
    Store,
    Status,
}